import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EMPTY, type Observable, of, switchMap } from 'rxjs';
import type { HighlightItem } from '../models/highlight-item.model';
import type { HighlightItemModel } from '../models/middleware/highlight-item.model';
import type { SingleItemResponse } from '../models/middleware/single-item-response.model';

@Injectable({
  providedIn: 'root',
})
export class HighlightService {
  private readonly http = inject(HttpClient);
  private readonly url = `/api/authenticated/event/highlight`;

  getHighlightedEvent(): Observable<HighlightItem> {
    return this.http.get<SingleItemResponse<HighlightItemModel>>(this.url, { observe: 'response' }).pipe(
      switchMap((response) => {
        if (response.status === 204 || !response.body?.data) {
          // TODO [#215]: use winston for logging
          console.debug('No highlight found');
          return EMPTY;
        } else {
          return of(this.convertToDisplayItem(response.body.data));
        }
      })
    );
  }

  private convertToDisplayItem(apiItem: HighlightItemModel): HighlightItem {
    return {
      eventType: apiItem.eventType,
      eventDocumentId: apiItem.eventDocumentId,
      expiryDate: new Date(apiItem.expiryDate),
      banner: apiItem.banner,
    };
  }
}
